export function veiculosInRequest(params = {}) {
  return {
    type: '@veiculo/VEICULOS_IN_REQUEST',
    payload: { params },
  };
}

export function findVeiculo(idveiculo) {
  return {
    type: '@veiculo/FIND_VEICULO',
    payload: { idveiculo },
  };
}

export function failedRequest() {
  return {
    type: '@veiculo/FAILED_REQUEST',
  };
}

export function deleteVeiculo(idveiculo, params) {
  return {
    type: '@veiculo/DELETE_VEICULO',
    payload: { idveiculo, params },
  };
}

export function updateVeiculo(veiculo, params) {
  return {
    type: '@veiculo/UPDATE_VEICULO',
    payload: { veiculo, params },
  };
}

export function storeVeiculo(veiculo, params) {
  return {
    type: '@veiculo/STORE_VEICULO',
    payload: { veiculo, params },
  };
}

export function successInRequest(
  veiculos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@veiculo/SUCCESS_IN_REQUEST',
    payload: { veiculos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(veiculo) {
  return {
    type: '@veiculo/SUCCESS_REQUEST',
    payload: { veiculo },
  };
}

export function successRemove(params) {
  return {
    type: '@veiculo/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@veiculo/RECORD_FILTERING',
    payload: { params },
  };
}
